import React from 'react';
import { string, array, shape } from 'prop-types';

export default function NewsTile({ item, viewMoreText }) {
    return (
        <a href={item.url} className="c-base-tile c-listing-tile c-news-tile">
            <div className="tile-content">
                <div className="tile-thumbnail">
                    <img src={item.thumbnail} alt={item.title} />
                </div>

                <div className="tile-description">
                    <span className="date">{item.date}</span>
                    {item.categories.map(category => (
                        <span className="category" key={category}>{category}</span>
                    ))}
                    <div className="title">{item.title}</div>
                    {item.excerpt && <p>{item.excerpt}</p>}
                    <div className="cta">{viewMoreText}</div>
                </div>
            </div>
        </a>
    );
}

NewsTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        thumbnail: string,
        title: string.isRequired,
        subtext: string,
        excerpt: string,
        date: string.isRequired,
        categories: array
    }).isRequired,
    viewMoreText: string.isRequired
    /* eslint-enable react/no-typos */
};
